import { Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { useHideLimitedCompanyShiftFields } from 'ogp/limited-company-capabilities';
import React from 'react';
import { CalendarJobType } from './calendar-job-type';
import { CalendarPlanningShift } from '../calendar-planning-shift.types';

export type GridDepartmentProps = {
  department: {
    id: string;
    name: string;
    jobTypes: {
      id: string;
      name: string;
      shifts: CalendarPlanningShift[];
    }[];
  };
};

export const CalendarDepartment = React.memo(
  ({ department }: GridDepartmentProps) => {
    const hideLimitedCompanyShiftFields = useHideLimitedCompanyShiftFields();

    return (
      <Section>
        {hideLimitedCompanyShiftFields ? null : (
          <StyledName title={department.name}>{department.name}</StyledName>
        )}
        {department.jobTypes.length ? (
          department.jobTypes.map((jobType) => (
            <CalendarJobType key={jobType.id} jobType={jobType} />
          ))
        ) : (
          <CalendarJobType jobType={undefined} />
        )}
      </Section>
    );
  },
  (prev, next) => {
    if (prev.department.id !== next.department.id) {
      return false;
    }
    if (prev.department.jobTypes.length !== next.department.jobTypes.length) {
      return false;
    }
    if (JSON.stringify(prev.department) !== JSON.stringify(next.department)) {
      return false;
    }
    return true;
  }
);

const Section = styled('section')(({ theme }) => ({
  minHeight: theme.spacing(8),
}));

const StyledName = styled(Typography)(() => ({
  fontWeight: 700,
  width: '14vw',
  position: 'relative',
  transform: 'translateY(-20%)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'pre',
}));
